import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router';

import { BASE_FLOW_SUBSCRIPTION_ID } from '@brightlocal/shared';

const SignUpIndexRedirect = () => {
  const search = useSearch({ strict: false });

  return <Navigate params={{ id: BASE_FLOW_SUBSCRIPTION_ID }} search={search} to="/auth/sign-up/$id" />;
};

export const Route = createFileRoute('/auth/sign-up/')({
  component: SignUpIndexRedirect
});
